import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { toRefs, ref, onMounted } from 'vue';
import Dialog from 'primevue/dialog';
import { EMIT } from '@/enum';
import { useStudentReferralStore } from '@/store';
import { StudentClinicianInterface } from '@/types';

interface PropsInterface {
  ids?: number[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAssignToServiceProvider',
  props: {
    ids: {}
  },
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const { ids } = toRefs(props);

const serviceProvider = ref();

const modalVisible = ref(true);

const referralStore = useStudentReferralStore();

onMounted(() => {
  if (ids.value) referralStore.getCliniciansAvailableForReferral(ids.value);
});

const save = () => {
  emit(EMIT.SAVE, serviceProvider.value);
  modalVisible.value = false;
};

const cancel = () => {
  emit(EMIT.CANCEL);
  modalVisible.value = false;
  return;
};

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createBlock(_unref(Dialog), {
    visible: modalVisible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((modalVisible).value = $event)),
    draggable: false,
    class: "dialog__container assign__dialog__container",
    closable: false,
    modal: true,
    onHide: cancel
  }, {
    header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("h2", { textContent: 'Assign to Service Provider' }, null, -1)
    ]))]),
    default: _withCtx(() => [
      (_unref(referralStore).serviceProviders?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[3] || (_cache[3] = _createElementVNode("label", { for: "service_provider" }, "Service Provider", -1)),
            _createVNode(_component_Dropdown, {
              modelValue: serviceProvider.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((serviceProvider).value = $event)),
              type: "secondary",
              options: _unref(referralStore).serviceProviders,
              "option-label": "full_name",
              placeholder: "Select Service Provider"
            }, null, 8, ["modelValue", "options"])
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_2, "Sorry there are no Service Providers."))
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_AppButton, {
        id: "cancel_service_btn",
        type: "secondary",
        text: "Cancel",
        onClick: cancel
      }),
      _createVNode(_component_AppButton, {
        id: "save_service_btn",
        type: "primary",
        text: "Assign",
        onClick: save
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})